import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import * as AuthHelper from '@Services/Auth/AuthHelper';

export async function getRecentHistory() {
  return (AuthHelper.getUser() && AuthHelper.getUser().history && AuthHelper.getUser().history.recentSearches) || [];
}

export async function getSavedHistory() {
  return MessageBroker.send(RequestUrls.getHistory, null, { cache: false });
}

export async function saveHistory(historyItem) {
  return MessageBroker.send(RequestUrls.saveHistory, historyItem);
}

export async function modifyHistory(historyItem) {
  return MessageBroker.send(RequestUrls.modifyHistory, historyItem);
}

export async function removeHistory(historyItem) {
  return MessageBroker.send(RequestUrls.removeHistory, historyItem);
}

export async function getHistoryTypes() {
  return MessageBroker.send(RequestUrls.getHistoryTypes);
}

export async function restoreHistory(historyItem) {
  return MessageBroker.send(RequestUrls.restoreHistory, historyItem);
}
